import React from 'react';
import './Product.css';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Rating from '@material-ui/lab/Rating';
import { PostToBaske } from '../Redux/ActionCreator';
import { connect } from 'react-redux';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 140,
  },
});

const mapStateToProps = (state) => {
  return {
    Basket: state.Basket,
  };
};
// --------------------------------------Fetching Peocess ------------------------------//
const mapDispatchToProps = (dispatch) => ({
  PostToBaske: (myObject) => dispatch(PostToBaske([myObject])),
});

function Product(props) {
  var addToBasket = () => {
    props.PostToBaske({
      title: props.title,
      discription: props.discription,
      rating: props.rating,
      image: props.image,
    });
  };
  const classes = useStyles();

  return (
    <div className="product">
      <Card className={classes.root}>
        <CardActionArea>
          <CardMedia
            className={classes.media}
            image={props.image}
            title={props.title}
          />
          <CardContent>
            <Typography gutterBottom variant="div" component="div">
              <Rating
                name="hover-feedback"
                value={props.rating}
                precision={0.5}
                // onChange={(event, newValue) => {
                //   setValue(newValue);
                // }}
                // onChangeActive={(event, newHover) => {
                //   setHover(newHover);
                // }}
              />
            </Typography>
            <Typography gutterBottom variant="h5" component="h2">
              {props.title}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              {props.discription}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Price :2000
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button
            size="small"
            color="primary"
            onClick={() => {
              addToBasket();
            }}
          >
            Add to basket
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Product);
